import { lazy } from "react";
import { detectHostTenant, isUploadHost } from "@/lib/hostTenant";
import { useHostname, SsrNavigate } from "@/lib/ssr";
import { HomeRoute } from "@/pages/home/HomeRoutes";

const UploadApp = lazy(() => import("@/pages/UploadApp"));

/**
 * The root path is context-dependent: on a tenant host (alias subdomain or
 * custom domain) it's the tenant's public site, so send it to /pages; on the
 * app host it's the marketing home. `useHostname` reads the SSR request host on
 * the server and `window.location` on the client, so this decision is stable
 * across SSR + hydration. HomeRoute picks the new home page where it's on (staging, src/lib/homeFlag.ts)
 * and today's Index everywhere else.
 */
const RootRoute = () => {
  const host = useHostname();
  // upload.photohawk.com → the standalone full-screen uploader.
  if (isUploadHost(host)) return <UploadApp />;
  if (detectHostTenant(host).type !== "app") return <SsrNavigate to="/pages" replace />;
  return <HomeRoute />;
};

export default RootRoute;
